<template>
    <div id="PatientClaimList">
    <div class="row">
      <div class="col-12">
        <MdTitleRegInfo
            v-bind:RegistrationInfo="PatientTitle" 
            v-bind:titlePrefix="$tc('PatientClaimList.PatientClaimTitle',2)" 
            v-bind:IsClinical="false"
            v-bind:titleRef="'titleElementPatientClaimList'"
            v-bind:patientCode="this.$route.params.id">
        </MdTitleRegInfo>
     
        <div class="alert alert-fill-warning d-flex align-items-center m-3" role="alert" v-if="isReadOnly">
               <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
               <div class="flex-grow-1">
                 <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
               </div>
             </div>
            <div class="row">
                <div class="col-sm-12 col-md-3">                      
                    <MdButton
                      v-bind:Label="$t('PatientClaimList.AddClaim')" 
                      v-bind:ClassProp="isReadOnly ? 'btn btn-primary my-3 btn-block' : 'btn btn-primary my-3 btn-block btn-login'"
                      v-bind:IconClass="'ti-plus pr-1'"
                      v-on:click="AddClaim"
                      v-bind:isReadOnly="isReadOnly"
                      v-bind:Name="'btn_add_contact'">
                    </MdButton>
                </div>
                <div class="col-sm-12 col-md-9 mb-4">
                    <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                        <div class="input-group" dir="ltr">
                            <input 
                              type="text" 
                              class="form-control"
                              :dir="dirInput"
                              v-model="parameter.SearchCriteria"   
                                @keyup.enter="SearchClaim"                            
                            >
                            <div class="input-group-append">
                                <div class="input-group-append">
                                <MdButton 
                                  v-bind:Name="'btnsearchinput'"
                                  v-bind:VariantProp="'btn btn-sm search-attached'"
                                  v-bind:IconClass="'mdi mdi-magnify'"
                                  v-on:click="SearchClaim">
                                </MdButton>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>              
        </div>
    </div>

    <b-row>
        <b-col lg="3" md="3" sm="12">
           <!-- <MdEdit 
                v-bind:Label="$t('Shared.datefrom')"                      
                v-bind:TypeProp="'date'" 
                v-bind:Min="'1900-01-01'"
                v-bind:OnPressEnter="SearchClaim"
                v-bind:Max="'2200-12-31'"               
                v-bind:Name="'DateFrom'"
                ref="DateFrom"                        
                v-model="DateFrom"/>   -->
                <MdDateTime 
                  :Label="$t('Shared.datefrom')" 
                  :Model="DateFrom"                           
                  @input="DateFrom = $event"                            
                  :Id="'PatientClaimListDateFrom'"
                  :Type="'date'"
                  :OnPressEnter="SearchClaim"
                  :isRequired="false"                           
                  :isConfirm="false"
                  :ReadOnly="false">
              </MdDateTime>       
        </b-col>
        <b-col lg="3" md="3" sm="12">
            <!--<MdEdit 
                v-bind:Label="$t('Shared.dateTo')"                      
                v-bind:TypeProp="'date'" 
                v-bind:OnPressEnter="SearchClaim"
                v-bind:Min="'1900-01-01'"
                v-bind:Max="'2200-12-31'"                 
                v-bind:Name="'DateTo'" 
                ref="DateTo"                     
                v-model="DateTo"/>-->
                <MdDateTime 
                  :Label="$t('Shared.dateTo')" 
                  :Model="DateTo"                           
                  @input="DateTo = $event"                            
                  :Id="'PatientClaimListDateTo'"
                  :Type="'date'"
                  :OnPressEnter="SearchClaim"
                  :isRequired="false"                           
                  :isConfirm="false"
                  :ReadOnly="false">
              </MdDateTime>     
        </b-col>
         <b-col lg="3" md="3" sm="12">             
            <MdSelect
                v-bind:Label="$t('Shared.Status')"
                v-bind:Options="ListStatus"
                v-bind:ModelArray="status"
                v-bind:FieldDescription="'name'"
                v-bind:FieldCode="'value'"                      
                :Input="ChangeStatus"/>
        </b-col>
        <b-col lg="3" md="3" sm="12">
            <div class="text-center text-md-right mt-3">
				<button 												
					type="button"
                    v-on:click="SearchClaim"
					class="btn btn-primary btn-login mx-2 pull-right"												
					id="btnsearchinput">
					{{ $t('Shared.Search') }}
				</button>
			</div>
        </b-col>   
    </b-row>

     <MdTitle v-bind:Text="ViewText" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/> 


    <MdTable 
        v-bind:fields="fields"
        v-bind:items="items"
        v-bind:totalRows="totalRows"              
        v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
        v-bind:currentPage="currentPage"
        v-bind:perPage="perPage"              
        v-bind:pageOptions="pageOptions"
        :editIconEvent="EditClaim"
         v-bind:FieldsDate="FieldsDateArr"
        v-bind:VisibleEditIcon="true"               
        :onRowSelected="onRowSelected"        
        :pageChanged="pageChanged"
        :perPageFunction="PerPageFunction"
        :otherIcon="'printer-fill'"
        :otherIconEvent="showReport">                
    </MdTable>


      <div class="space-actions"></div>
      <div class="page-actions">  
           <b-dropdown id="dropdown-dropup" dropup :text="$tc('Shared.ActionsTxt',2)" variant="primary" class="m-2">      
                <b-dropdown-item  href="#" v-on:click="showReport()">{{$t('schedulerDB.dropdown.Report')}}</b-dropdown-item>   
                <b-dropdown-item  href="#">1 ECS FLAG</b-dropdown-item>      
                <b-dropdown-item  href="#">2 PAID FLAG</b-dropdown-item>       
                <b-dropdown-item  href="#">PRINT FLAG</b-dropdown-item>       
                <b-dropdown-item  href="#">ALL FLAGS</b-dropdown-item>  
                <b-dropdown-item  href="#">SHOW IN PORTAL</b-dropdown-item>      
                <b-dropdown-item  href="#">HISTORY</b-dropdown-item>       
                <b-dropdown-item  href="#">VOID</b-dropdown-item>       
                <b-dropdown-item  href="#">EDIT</b-dropdown-item>
                <b-dropdown-item  href="#">DETAIL</b-dropdown-item> 
                <!-- <b-dropdown-item-button v-if="visibleVoid"> {{ $t('Shared.Void') }}</b-dropdown-item-button> -->
            </b-dropdown>          
        </div>


    </div>
</template>

<script>

import EnumService from '@/services/enum.service' 
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import Utils from '@/common/utils'
import Permission from '@/common/Permission'
import ClaimList from '@/services/claimlist.service';

export default {
  name: 'PatientClaimList',
  mixins: [ShowMessage, DBFunctions, Permission],
  data(){
    return{
        items:[],
        pageOptions: [5, 10, 15 ],
        totalRows: 0,
        currentPage: 1,
        perPage: 10,
        FieldsDateArr:['dateFrom','dateTo','datePaid','sysDate'],
        fields: [
          { key: 'issLineNo', sortable: true, label: this.$t('PostPayment.IssLineNo'), class: 'text-left'},  
          { key: 'recId', sortable: true, label: this.$t('PatientClaimList.RecId'), class: 'text-right hidden'},        
          { key: 'sendFlag', sortable: true, label: this.$t('PatientClaimList.SendFlag'), class: 'text-left'},       
          { key: 'paidFull', sortable: true, label: this.$t('PatientClaimList.PaidFull'), class: 'text-left' }, 
          { key: 'printFlag', sortable: true, label: this.$t('PatientClaimList.PrintFlag'), class: 'text-left' },
          { key: 'dateFrom', sortable: true, label: this.$t('Shared.datefrom'), class: 'text-left' }, 
          { key: 'dateTo', sortable: true, label: this.$t('Shared.dateTo'), class: 'text-left' },            
          { key: 'posCode', sortable: true, label: this.$t('PatientClaimList.PosCode'), class: 'text-left' },
          { key: 'cptHcpcs', sortable: true, label: this.$t('PatientClaimList.CptHcpcs'), class: 'text-left' }, 
          { key: 'hcpcsCode', sortable: true, label: this.$t('PostPayment.HCPCSCode'), class: 'text-left' },
          { key: 'Modifier1', sortable: true, label: this.$t('PatientClaimList.Modifier',{'num': 1 }), class: 'text-left' },
          { key: 'Modifier2', sortable: true, label: this.$t('PatientClaimList.Modifier',{'num': 2 }), class: 'text-left' },
          { key: 'Modifier3', sortable: true, label: this.$t('PatientClaimList.Modifier',{'num': 3 }), class: 'text-left' },
          { key: 'Modifier4', sortable: true, label: this.$t('PatientClaimList.Modifier',{'num': 4 }), class: 'text-left' },
          { key: 'diagCode', sortable: true, label: this.$t('PatientClaimList.DiagCode'), class: 'text-left' },
          { key: 'dayUnit', sortable: true, label: this.$t('PatientClaimList.DayUnit'), class: 'text-left' },
          { key: 'charges', sortable: true, label: this.$t('HouseFile.Charges'), class: 'text-left' },
          { key: 'Amtapproved', sortable: true, label: this.$t('PatientClaimList.Amtapproved'), class: 'text-left' },
          { key: 'tosCode', sortable: true, label: this.$t('PatientClaimList.TosCode'), class: 'text-left' },
          { key: 'paid', sortable: true, label: this.$t('PatientClaimList.Paid'), class: 'text-left' },
          { key: 'unitPrice', sortable: true, label: this.$t('drug.UnitPrice'), class: 'text-left' },
          { key: 'electronic', sortable: true, label: this.$t('PatientClaimList.Electronic'), class: 'text-left' },
          { key: 'repeatDone', sortable: true, label: this.$t('PatientClaimList.RepeatDone'), class: 'text-left' },
          { key: 'masterLineNo', sortable: true, label: this.$t('PatientClaimList.MasterLineNo'), class: 'text-left' },
          { key: 'paidAmt', sortable: true, label: this.$t('PatientClaimList.PaidAmt'), class: 'text-left' },
          { key: 'datePaid', sortable: true, label: this.$t('PatientClaimList.DatePaid'), class: 'text-left' },
          { key: 'generationType', sortable: true, label: this.$t('PatientClaimList.GenerationType'), class: 'text-left' },
          { key: 'chkno', sortable: true, label: this.$t('PatientClaimList.Chkno'), class: 'text-left' },
          { key: 'insuranceCode', sortable: true, label: this.$t('Insurance.InsuranceCode'), class: 'text-left' },
          { key: 'primInsuranceNo', sortable: true, label: this.$t('PatientClaimList.PrimInsuranceNo'), class: 'text-left' },
          { key: 'InsuranceCode1', sortable: true, label: this.$t('PatientClaimList.InsuranceCode',{'num': 1 }), class: 'text-left' },
          { key: 'secInsuranceNo', sortable: true, label: this.$t('PatientClaimList.SecInsuranceNo'), class: 'text-left' },
          { key: 'insuranceCode2', sortable: true, label: this.$t('PatientClaimList.InsuranceCode',{'num': 2 }), class: 'text-left' },
          { key: 'terInsuranceNo', sortable: true, label: this.$t('PatientClaimList.TerInsuranceNo'), class: 'text-left' },
          { key: 'sysDate', sortable: true, label: this.$t('PatientClaimList.SysDate'), class: 'text-left' },
          { key: 'seqNo', sortable: true, label: this.$t('PatientClaimList.SeqNo'), class: 'text-left' },
          { key: 'diagInd', sortable: true, label: this.$t('PatientClaimList.DiagInd'), class: 'text-left' },
          { key: 'docInd', sortable: true, label: this.$t('PatientClaimList.DocInd'), class: 'text-left' },
          { key: 'valueCode', sortable: true, label: this.$t('Shared.ValueCode'), class: 'text-left' },
          { key: 'valueCodeAmt', sortable: true, label: this.$t('PatientClaimList.ValueCodeAmt'), class: 'text-left' },
          { key: 'claimSource', sortable: true, label: this.$t('PatientClaimList.ClaimSource'), class: 'text-left' },
          { key: 'conditionCode1', sortable: true, label: this.$t('PatientClaimList.ConditionCode',{'num': 1 }), class: 'text-left' },
          { key: 'conditionCode2', sortable: true, label: this.$t('PatientClaimList.ConditionCode',{'num': 2 }), class: 'text-left' },
          { key: 'conditionCode3', sortable: true, label: this.$t('PatientClaimList.ConditionCode',{'num': 3 }), class: 'text-left' },
          { key: 'conditionCode4', sortable: true, label: this.$t('PatientClaimList.ConditionCode',{'num': 4 }), class: 'text-left' },
          { key: 'conditionCode5', sortable: true, label: this.$t('PatientClaimList.ConditionCode',{'num': 5 }), class: 'text-left' },
          { key: 'conditionCode6', sortable: true, label: this.$t('PatientClaimList.ConditionCode',{'num': 6 }), class: 'text-left' },
          { key: 'conditionCode7', sortable: true, label: this.$t('PatientClaimList.ConditionCode',{'num': 7 }), class: 'text-left' },
          { key: 'doctorCode', sortable: true, label: this.$t('PatientClaimList.DoctorCode'), class: 'text-left' },
          { key: 'paymentPercent', sortable: true, label: this.$t('PatientClaimList.PaymentPercent'), class: 'text-left' },
          { key: 'facilityCode', sortable: true, label: this.$t('PatientClaimList.FacilityCode'), class: 'text-left' },
          { key: 'showInPatientPortal', sortable: true, label: this.$t('ActList.ShowToPatient'), class: 'text-left' },            
      ],
        ShowMessageIsEmpty:false,
        status:{value:'All',name: this.$t('Shared.All')},
        ListStatus:EnumService.StatusClaimList,
        ViewText:this.$t('Shared.SearchResult') +" - Amt Billed: $0.00 - Amt Paid: $0.00 - Balance: $0.00 - Credit: $0.00",
        DateFrom:null,
        DateTo:null,
        isReadOnly: false,
        PatientTitle:{      
        programName:'',
        fullName:'',
        admitDate:'',
        dischargeDate:'',
        dob:'',
        activitytypename:'',
        startdatetime:'',
        ageFormatted:''
      },
      parameter:{
        SearchCriteria:'',
        PageNumber : 0,
        PageSize:0 ,
        PatientCode:'', 
        Status:"",            
      },
        OptionsRightMenu:{
            visible:true,
            ItemsList:[],
            btnvisible:true,
            itemdisabled: false,
            PatientCode:''         
        },
        dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr', 
    }
  },

  methods:{
    AddClaim(){
        this.$router.push({ name: "claim-add", params: { id: this.$route.params.id} });
    },

    PerPageFunction(perpage){
        this.perPage = perpage;  
        this.currentPage = 1;
        this.SearchClaim();   
    },

    pageChanged(page){
        this.currentPage = page;    
        this.SearchClaim();   
    },

    

    showReport(){

    },

    onRowSelected(){

    },

    SearchClaim(){
        this.getClaimList();
    },

    ChangeStatus(){

    },

    EditClaim(row){
        this.$router.push({ name: "claim-details", params: { id: this.$route.params.id,recId:row.recId} });
    },

    async getClaimList() {
           this.items = [];     
            this.parameter.DateFrom = this.DateFrom;
            this.parameter.DateTo = this.DateTo;
            this.parameter.PageSize = this.perPage;
            this.parameter.PageNumber = this.currentPage; 
            this.parameter.PatientCode = this.$route.params.id;           
            await ClaimList.getAll(this.parameter).then((response) => {
              
              if(response.status == '200'){          
                let headerString = response.headers["x-pagination"];
                this.Header = JSON.parse(headerString);
                this.totalRows = this.Header.TotalCount;  
                
                this.items = response.data;
 
                this.items.forEach(element => {             
                    element.dateFrom = element.dateFrom ? Utils.formatterDateToString(element.dateFrom) : null;
                    element.dateTo =  element.dateTo ? Utils.formatterDateToString(element.dateTo) : null; 
                    element.datePaid = element.datePaid ? Utils.formatterDateToString(element.datePaid) : null; 
                    element.sysDate = element.sysDate ? Utils.formatterDateToString(element.sysDate) : null; 
                })         
              }
               
              if(this.items.length === 0){              
                this.ShowMessageIsEmpty = true;
              }
             
           
            }).catch(error => {             
              if (!error.response) {
                  // network error
                  this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
              } else {
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
                })
          },

    async GetPatientByCode(){
      var infoList = await this.getInfoTitle(this.$route.params.id);
      if(infoList.length > 0){
        this.PatientTitle.programName = '';
        this.PatientTitle.admitDate = '';
        this.PatientTitle.dischargeDate = '';

        const { dob, firstname, lastname, age, ageFormatted } = infoList[0]; // Destructure for easier access

        if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
        if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
        if (age) this.PatientTitle.age = age;
        if (firstname) this.PatientTitle.fullName = firstname + ' '+ lastname;     
      }
    },
  },

  created(){

  },

  async mounted(){
    this.OptionsRightMenu.visible = true;   
    this.OptionsRightMenu.ItemsList = EnumService.PatientItems;
    this.$emit("getVisibleMenu", this.OptionsRightMenu); 
    this.isReadOnly = this.$store.state.isPatientClaimsEHRReadOnly;
    await this.GetPatientByCode();
    this.getClaimList();
  }
   
};
</script>


